import type { MailOutboxFilters } from "@/lib/notification.api";
import { useMailOutboxList, useMailOutboxTemplateKeys } from "@/hooks/queries/useMailOutboxList";

export function useMailOutboxPageData(filters: MailOutboxFilters) {
  const { data, isLoading, isFetching } = useMailOutboxList(filters);
  const { data: templateKeys = [] } = useMailOutboxTemplateKeys();

  return {
    rows: data?.data ?? [],
    total: data?.total ?? 0,
    templateKeys,
    isLoading,
    isFetching,
  };
}
